import './CastButton.scss';
import { jsx } from 'react/jsx-runtime';

/* External */

function CastButton() {
  return /*#__PURE__*/jsx("google-cast-launcher", {
    "class": "dtv-common-c-cast-button"
  });
}

export { CastButton as default };
//# sourceMappingURL=CastButton.js.map
